var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{staticClass:"bg-transparent form-control rounded-0",class:_vm.classes,attrs:{"disabled":_vm.disabled,"type":_vm.type,"placeholder":_vm.placeholder},domProps:{"value":_vm.inputValue},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }